import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "mt20 w100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_8 = {
  class: "text pad10",
  style: {"color":"#696969"}
}
const _hoisted_9 = { class: "mt10 mb20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs13" }, [
  /*#__PURE__*/_createTextVNode(" この公開ページを編集できる、同一グループに属しているメンバーを設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 編集権限をもつと公開ページの編集および紐づく調整カレンダーの設定内容を変更いただけます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 共有されたメンバーは、オーナーであるあなたに紐づく外部カレンダーも同時に確認できるようになります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 共有先が複数の場合は、カンマ区切りで入力してください。 ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "mt10"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: `send_mail_fix_member_`,
  class: "fs12 pointer"
}, " 招待メール通知（下記にメッセージがない場合は招待メールが送信されません）", -1)
const _hoisted_15 = {
  key: 0,
  class: "mt5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 150px)"}
}
const _hoisted_18 = { class: "text pad10" }
const _hoisted_19 = {
  key: 0,
  class: "w100"
}
const _hoisted_20 = {
  key: 0,
  class: "centered"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "grey mt20" }, "この公開ページの編集権限を共有したメンバーはいません。", -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "fl arial" }
const _hoisted_26 = {
  class: "fs28 fw600",
  style: {"margin-left":"12px"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "人に共有済みです", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = { class: "fl mr10 ml10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "grey fs9" }
const _hoisted_33 = { class: "fl mr5 mt2" }
const _hoisted_34 = {
  style: {"width":"35px","margin-top":"-13px"},
  class: "fr mr10"
}
const _hoisted_35 = ["src", "onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = { key: 2 }
const _hoisted_39 = {
  class: "text pad10",
  style: {"color":"#696969"}
}
const _hoisted_40 = { class: "mt10 mb20" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "fs13" }, [
  /*#__PURE__*/_createTextVNode(" この公開ページを編集できる、外部グループを設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 外部グループも公開ページ・調整カレンダーの編集が行え、確定した内容は、このグループと外部グループにも共有されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 外部グループが、調整カレンダーに外部カレンダー（MS/Googleカレンダー）を連携してもこのグループでは見えませんので、安心して共有いただけます。 ")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pointer centered circle_button skyblueBg fs14 rad8 mr20 fw600" }, " オプション利用をリクエスト "),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = {
  key: 0,
  class: "mt10"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: `send_mail_fix_member_`,
  class: "fs12 pointer"
}, " 招待メール通知（下記にメッセージがない場合は招待メールが送信されません）", -1)
const _hoisted_47 = {
  key: 0,
  class: "mt5"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = {
  key: 1,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_50 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "追加", -1)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ShareAuthModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(`roomsCategoryTab categoryAll pointer centered fl ${_ctx.viewType == 'addMember' ? 'selected fw600' : ''}`),
            style: {"width":"50%"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeViewType(`addMember`)))
          }, " 編集権限を追加 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.viewType == 'showSharedMembers' ? 'selected fw600' : ''
                    }`),
            style: {"width":"50%"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeViewType(`showSharedMembers`)))
          }, " 共有済み ", 2),
          false
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.viewType == 'addOuterUGMember' ? 'selected fw600' : ''
                    }`),
                style: {"width":"33%"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeViewType(`addOuterUGMember`)))
              }, " 外部グループに共有 ", 2))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        (_ctx.viewType == `addMember`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_TextfieldTag, {
                    placeholder: "メールアドレス",
                    style: {"border-bottom":"solid 1px #c8c8c8"},
                    class: "cal_blanks fw600 fl fs12 mr5 w60 mt20",
                    list: "ctagList",
                    id: "add_attends_email",
                    value: _ctx.memberEmailsValue,
                    onInputValue: _ctx.inputEmail
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_11
                ]),
                _hoisted_12,
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_CheckboxTag, {
                        value: ``,
                        name: `send_mail_fix_member`,
                        checked: _ctx.sendMailFixMember,
                        prefix: `send_mail_fix_member`,
                        onClickCheckbox: _ctx.clickSendMailFixMember,
                        style: {"margin-left":"10px"}
                      }, null, 8, ["checked", "onClickCheckbox"]),
                      _hoisted_14,
                      (_ctx.sendMailFixMember)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_TextareaTag, {
                              placeholder: "全員の予定が集まりましたら日程の確定をお願いいたします。",
                              style: {"height":"120px"},
                              class: "fs14 roundForm mw100",
                              value: _ctx.message,
                              onInputValue: _ctx.inputMessage
                            }, null, 8, ["value", "onInputValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_16
              ])
            ]))
          : (_ctx.viewType == `showSharedMembers`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.sharedMembers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_ctx.sharedMembers.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _hoisted_21,
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                width: "40",
                                height: "40"
                              }, null, 8, _hoisted_22),
                              _hoisted_23
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.sharedMembers.length), 1),
                                _hoisted_27,
                                _hoisted_28
                              ]),
                              _hoisted_29,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedMembers, (user, memindex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "fs14 fw600 borderGrey w100 pad15",
                                  key: memindex
                                }, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_UserIcon, {
                                      member: user,
                                      width: 38,
                                      canEdit: false,
                                      updateSelf: false,
                                      showTooltip: false
                                    }, null, 8, ["member"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(user.name), 1),
                                    _hoisted_31,
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.truncate(user.email, 40)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _withDirectives(_createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                        width: "22",
                                        height: "25",
                                        class: "fr pointer",
                                        onClick: ($event: any) => (_ctx.deleteSharedMember(user))
                                      }, null, 8, _hoisted_35), [
                                        [_directive_tooltip, `権限を削除`]
                                      ]),
                                      _createTextVNode("   ")
                                    ]),
                                    _hoisted_36
                                  ])
                                ]))
                              }), 128)),
                              _hoisted_37
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
        (false && _ctx.viewType == `addOuterUGMember`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _hoisted_42,
                  _createElementVNode("div", null, [
                    false
                      ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                          key: 0,
                          placeholder: "会社名",
                          style: {"border-bottom":"solid 1px #c8c8c8"},
                          class: "cal_blanks fw600 fl fs12 mr5 w60 mt20",
                          list: "ctagList",
                          id: "add_attends_email",
                          value: _ctx.memberEmailsValue,
                          onInputValue: _ctx.inputEmail
                        }, null, 8, ["value", "onInputValue"]))
                      : _createCommentVNode("", true),
                    false
                      ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                          key: 1,
                          placeholder: "メールアドレス",
                          style: {"border-bottom":"solid 1px #c8c8c8"},
                          class: "cal_blanks fw600 fl fs12 mr5 w60 mt20",
                          list: "ctagList",
                          id: "add_attends_email",
                          value: _ctx.memberEmailsValue,
                          onInputValue: _ctx.inputEmail
                        }, null, 8, ["value", "onInputValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_43
                ]),
                _hoisted_44,
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(_component_CheckboxTag, {
                        value: ``,
                        name: `send_mail_fix_member`,
                        checked: _ctx.sendMailFixMember,
                        prefix: `send_mail_fix_member`,
                        onClickCheckbox: _ctx.clickSendMailFixMember,
                        style: {"margin-left":"10px"}
                      }, null, 8, ["checked", "onClickCheckbox"]),
                      _hoisted_46,
                      (_ctx.sendMailFixMember)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createVNode(_component_TextareaTag, {
                              placeholder: "全員の予定が集まりましたら日程の確定をお願いいたします。",
                              style: {"height":"120px"},
                              class: "fs14 roundForm mw100",
                              value: _ctx.message,
                              onInputValue: _ctx.inputMessage
                            }, null, 8, ["value", "onInputValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_48
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.viewType == `addMember`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("section", {
                class: "with_white_bg dgrey fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
              }, _hoisted_52)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("section", {
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
              }, _hoisted_55)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}